<label class="custom-checkbox py-3 cursor-pointer" [ngClass]="checked ? 'checked' :'unchecked'">
  <div class="ml-4 mr-3 d-flex">
    <input class="cursor-pointer" type="checkbox" (change)="checkedChange.emit($event)" [checked]="checked" />
  </div>
  <div class="d-flex flex-wrap">
    <b class="title">{{title}}&nbsp;</b>
    <span class="price pr-4">{{subtitle}}</span>
  </div>
</label>